var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPodcast = function SvgPodcast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1316.8 1392"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 658.4,
    cy: 620.8,
    r: 169.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M658.4 790.1c-119.9 0-212.6 105.1-197.7 224l34.9 279.1c7.1 56.5 55.1 98.9 112 98.9h101.7c56.9 0 104.9-42.4 112-98.9l34.9-279.1c14.8-119-78-224-197.8-224"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M969 959.2c75.5-77.9 122-184 122-300.8 0-238.6-194.1-432.6-432.6-432.6s-432.7 194-432.7 432.6c0 116.8 46.5 222.9 122 300.8 4.4-45.2 18.6-89 41.7-128.2-32.1-49.8-50.8-109.1-50.8-172.6 0-176.3 143.5-319.8 319.8-319.8S978.2 482 978.2 658.4c0 63.6-18.7 122.8-50.8 172.6 23 39.2 37.2 83 41.6 128.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M658.4 0C295.3 0 0 295.3 0 658.4c0 262.4 154.3 489.3 376.8 595.1l-17.4-139C211 1016.9 112.8 848.9 112.8 658.4c0-300.8 244.7-545.5 545.5-545.5s545.5 244.7 545.5 545.5c0 190.5-98.2 358.5-246.6 456.1l-17.4 139c222.6-105.7 376.8-332.7 376.8-595.1C1316.8 295.3 1021.4 0 658.4 0"
  })));
};
export default SvgPodcast;